import "./styles.scss"

const CardHeader = ({ title, children, className, moreButtons = undefined }) => {
  return (
    <div className={`header__container ${className ? className : ""}`}>
      {title && <h2 className="header__container-title">{title}</h2>}
      {moreButtons ? moreButtons : <></>}
      {children}
    </div>
  )
}

export default CardHeader
